var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMail = function SvgMail(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135,
    height: 71,
    fill: "none",
    viewBox: "0 0 135 71",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 88.755,
    height: 61.019,
    x: 41.943,
    y: 5.981,
    fill: "#FF5100",
    stroke: "#FF5100",
    strokeWidth: 8,
    rx: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 8,
    d: "m43.052 3.762 37.321 32.007a10 10 0 0 0 13.192-.15l35.469-31.857"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF5100",
    strokeLinecap: "round",
    strokeWidth: 8,
    d: "M34.987 17.192H13.486M42.575 36.164h-26.56M26.133 54.503H4"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMail);
export default ForwardRef;